/* src/app/components/switch/switch.component.less */
:host ::ng-deep .mdc-switch:enabled .mdc-switch__track::after {
  background: #f53173 !important;
}
:host ::ng-deep .mdc-switch:enabled .mdc-switch__shadow {
  background: #ffffff !important;
  box-shadow: 0px 2px 1px -1px #00000033 !important;
  box-shadow: 0px 1px 1px 0px #00000024 !important;
  box-shadow: 0px 1px 3px 0px #0000001F !important;
}
:host ::ng-deep .mdc-switch:enabled .mdc-switch__track::before {
  background: #f53173 !important;
}
:host ::ng-deep .mdc-switch.mdc-switch--selected:enabled .mdc-switch__icon {
  fill: none !important;
}
:host ::ng-deep .mdc-switch.mdc-switch--unselected:enabled .mdc-switch__icon {
  fill: none !important;
}
:host ::ng-deep .mat-mdc-slide-toggle .mdc-switch:enabled + .mdc-label {
  font-size: 24px !important;
  color: #ffffff !important;
}
/*# sourceMappingURL=switch.component-XGYJ4QVF.css.map */
